module.exports = __webpack_public_path__ + "static/media/dinosaur(24).28348206.PNG";